<p>Number of days frozen: {{ membership.days_remaining }}</p>
<p>New end date: {{ dateStringFromISO8601(membership.new_end_date_if_unfrozen) }}</p>

<div class="form-group">
  <label>Customize Customer Email Confirmation</label>
  <app-markdown-editor [(content)]="unfreezeEmailText" [id]="'unfreezeEmailText'"></app-markdown-editor>
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
